/* eslint-disable no-param-reassign */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { MyFleetVessel, MyFleetVessels } from '../../models/my-fleet.model';

interface MyFleetVesselsState {
  myFleetVesselsLoading: boolean;
  myFleetVesselsError: string | null;
  myFleetVessels: MyFleetVessels | null;
  searchFilterValue: string;
}

export const INITIAL_MY_FLEET_VESSELS_STATE: MyFleetVesselsState = {
  myFleetVesselsLoading: false,
  myFleetVesselsError: null,
  myFleetVessels: null,
  searchFilterValue: '',
};

const MyFleetVesselsSlice = createSlice({
  name: 'myFleetVessels',
  initialState: INITIAL_MY_FLEET_VESSELS_STATE,
  reducers: {
    setMyFleetVesselsLoading: (state, action: PayloadAction<boolean>) => {
      state.myFleetVesselsLoading = action.payload;
      state.myFleetVesselsError = null;
      state.myFleetVessels = null;
      state.searchFilterValue = '';
    },
    setMyFleetVesselsError: (state, action: PayloadAction<string | null>) => {
      state.myFleetVesselsError = action.payload;
      state.myFleetVesselsLoading = false;
      state.myFleetVessels = null;
      state.searchFilterValue = '';
    },
    setMyFleetVessels: (
      state,
      action: PayloadAction<MyFleetVessels | null>
    ) => {
      state.myFleetVessels = action.payload;
      state.myFleetVesselsLoading = false;
      state.myFleetVesselsError = null;
      state.searchFilterValue = '';
    },
    setSearchFilterValue: (state, action: PayloadAction<string>) => {
      state.searchFilterValue = action.payload;
    },
    updateVessel: (state, action: PayloadAction<MyFleetVessel>) => {
      if (state.myFleetVessels) {
        const index = state.myFleetVessels.findIndex(
          (vessel) => vessel.imo === action.payload.imo
        );
        if (index !== -1) {
          state.myFleetVessels[index] = action.payload;
        }
      }
    },
  },
});

export const {
  setMyFleetVesselsLoading,
  setMyFleetVesselsError,
  setMyFleetVessels,
  setSearchFilterValue,
  updateVessel,
} = MyFleetVesselsSlice.actions;

export default MyFleetVesselsSlice.reducer;
